// extracted by mini-css-extract-plugin
export default {"container":"gUEjLPws10Lu9gWYtOP6","button":"IaL5jiSotgXChV7BIYAI","buttonText":"hhAuvV7yFcPJMAoaGVN8","link":"KUZu_hJsSkWhpa2InUuZ"};